import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { LINK_HOME } from '../../brands/default/links';
import ThemeContext from '../../providers/ThemeProvider';

const HeaderLogo = ({ isMobile = false }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="d-flex col-4 col-md-auto align-items-center justify-content-center text-center">
        <div className="logo-container">
          <a href={`${LINK_HOME}/`}>
            <img
              alt="Logo"
              className="logo"
              height={isMobile ? '40px' : '59px'}
              src={theme.images.headerlogo}
              width={isMobile ? '50px' : '92px'}
            />
          </a>
        </div>
      </div>
      <style jsx>{`
        .logo-container {
          display: flex;
          min-height: 41px;
          align-items: center;
          justify-content: center;
          max-height: ${isMobile ? '26px' : '92px'};
          max-width: ${isMobile ? '80px' : '92px'};
          margin-top: ${isMobile ? '3px' : '0px'};
          margin-bottom: ${isMobile ? '4px' : '0px'};
        }
        .logo {
          display: flex;
          height: ${isMobile ? '40px' : 'auto'};
          width: ${isMobile ? '72px' : '92px'};
          align-self: flex-start;
        }
        .top {
          position: absolute;
          top: 50px;
        }
      `}</style>
    </>
  );
};

HeaderLogo.propTypes = {
  isMobile: PropTypes.bool,
};

export default HeaderLogo;
